module.exports = __webpack_public_path__ + "static/dinner-party-201fa5d7cedb3ae5074632ec58ef921e.jpg";